/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_Expense_BucketInputs */

const vi_error_invalid_expense_bucket = /** @type {(inputs: Error_Invalid_Expense_BucketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mốc thời gian của biểu đồ chỉ nhận ngày, tháng hoặc quý. Hãy tải lại trang báo cáo.`)
};

/**

* @param {Error_Invalid_Expense_BucketInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_invalid_expense_bucket = /** @type {((inputs?: Error_Invalid_Expense_BucketInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_Expense_BucketInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_invalid_expense_bucket(inputs)
});